<template>
  <div
    class="list"
    :class="{ clickable }"
  >
    <div class="columns">
      <div
        v-for="(item, i) in columns"
        :key="i"
        class="column"
      >
        {{ item.name }}
      </div>
    </div>
    <div
      v-if="items.length > 0"
      class="table"
    >
      <div
        v-for="(item, i) in items"
        :key="i"
        class="row"
        @click="click(item, $event)"
      >
        <div
          v-for="(column, j) in columns"
          :key="j"
          class="item"
          :title="formatValue(item[column.key])"
        >
          {{ formatValue(item[column.key]) }}
        </div>
        <div
          v-for="(button, x) in buttons"
          :key="`button-${x}`"
          class="button"
        >
          <button @click="emitCallback(button, item)">
            {{ button.name }}
          </button>
        </div>
      </div>
    </div>
    <div
      v-else
      class="no-data"
    >
      No data
    </div>
  </div>
</template>

<script>
  export default {
    name: 'List',
    components: {},
    props: {
      items: {
        type: Array,
        default: () => [],
      },
      columns: {
        type: Array,
        default: () => [],
      },
      buttons: {
        type: Array,
        default: () => [{ name: 'Edit', callback: 'edit' }],
      },
    },
    data() {
      return {
      };
    },
    computed: {
      clickable() {
        return !!this.$listeners.click;
      },
    },
    methods: {
      emitCallback(button, item) {
        this.$emit(button.callback, item);
      },
      click(item, e) {
        if (e.target.tagName !== 'BUTTON') {
          this.$emit('click', item);
        }
      },
      formatValue(value) {
        if (Array.isArray(value)) {
          return value.join(', ');
        }
        return value;
      },
    },
  };
</script>


<style lang="stylus" scoped>

  .list
    border: 1px solid black

    &.clickable
      .row
        cursor: pointer

        &:hover
          background-color: white
          opacity: 0.8

  .columns, .row
    display: flex

  .columns
    padding: 10px

  .row
    padding: 10px

  .columns
    border-bottom: 1px solid black

  .column
    padding: 0px 20px
    width: 200px
    text-overflow: ellipsis
    overflow: hidden
    white-space: nowrap

  .item
    padding: 0px 20px
    width: 200px
    text-overflow: ellipsis
    overflow: hidden
    white-space: nowrap

  .no-data
    min-height: 200px
    display: flex
    justify-content: center
    align-items: center

  button
    cursor: pointer
    margin-left: 10px
</style>
